<template>
    <transition name="custom-transition">
        <v-snackbar
            v-if="notification.show"
            v-model="notification.show"
            multi-line
            :style="getStyle"
            rounded="xl"
            :top="notification.verticalPosition === VerticalPositionEnum.Top"
            :bottom="notification.verticalPosition === VerticalPositionEnum.Bottom"
            right
            :timeout="getms"
            :color="notificationColor"
            elevation="24"
            @input="dismissNotification"
        >
            <div class="d-flex align-center">
                <v-icon>{{ iconChoice }}</v-icon>
                <span class="ml-4">{{ notification.text }}</span>
            </div>

            <template #action="{ attrs }">
                <v-btn dark text v-bind="attrs" @click="dismissNotification">
                    <v-icon>{{ ICONS.close }}</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </transition>
</template>

<script>
import { defineComponent } from 'vue';
import useSettings from '../../modules/settings.module';
import { ICONS, StatusEnum, VerticalPositionEnum } from '../../constants';

export default defineComponent({
    setup() {
        const { notification, dismissNotification } = useSettings();

        return {
            notification, dismissNotification,
        };
    },
    data() {
        return {
            ICONS,
            VerticalPositionEnum,
            offsetTop: 50,
        };
    },
    computed: {
        getms() {
            if (this.notification.status === StatusEnum.Error || this.notification.status === StatusEnum.Warning) {
                return this.notification.ms ?? 6000;
            } else {
                return this.notification.ms ?? 3000;
            }
        },
        iconChoice() {
            switch (this.notification.status) {
                case StatusEnum.Error:
                    return ICONS.alert;
                case StatusEnum.Warning:
                    return ICONS.info;
                default:
                    return ICONS.success;
            }
        },
        notificationColor() {
            switch (this.notification.status) {
                case StatusEnum.Error:
                    return 'red accent-4';
                case StatusEnum.Warning:
                    return 'orange accent-4';
                default:
                    return 'success';
            }
        },
        getStyle() {
            return {
                top: this.notification.verticalPosition === VerticalPositionEnum.Top ? `${this.offsetTop}px` : '',
                position: 'fixed',
            };
        },
    },
});
</script>

<style lang="scss" scoped>
.custom-transition-enter-active,
.custom-transition-leave-active {
    transition: opacity 0.4s ease, transform 0.4s ease;
}
.custom-transition-enter,
.custom-transition-leave-to {
    opacity: 0;
    transform: translateX(20px);
}
</style>

